import { render } from "./InputAudio.vue?vue&type=template&id=b18b06fc&scoped=true"
import script from "./InputAudio.vue?vue&type=script&lang=js"
export * from "./InputAudio.vue?vue&type=script&lang=js"

import "./InputAudio.vue?vue&type=style&index=0&id=b18b06fc&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18b06fc"]])

export default __exports__